'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _payment = require('../actions/payment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getAccountPaymentDetails),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getAccountCreditCards),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(getPaymentMethods),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getVaidTransactionByTransactionKey),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(addPaymentTransactionSaga),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(updatePaymentMethodSaga),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(setPaymentMethodSaga),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(schedulesSaga);

var paymentHeaders = [{
  key: 'x-vzt-authorization',
  value: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBpZCI6InNlcnZpY2VzIiwiZXhwIjoxNTI2NDAxMzc2LjAsIm5uYyI6IjZiZjk3NTk3ZDliNTczYmUifQ.qlUP48qVZc-0ocJl8ZM1un2b6-c34VhUs2Pa89EKkME'
}, {
  key: 'x-vzt-component',
  value: 'AMWeb'
}];

function getAccountPaymentDetails(action) {
  var paymentDetailsApi, paymentDetailsApiResponse;
  return _regenerator2.default.wrap(function getAccountPaymentDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          paymentDetailsApi = new _webUtils.API();
          _context.next = 3;
          return paymentDetailsApi.get('' + _webUtils.Urls.payment.getAccountPaymentDetails + action.accountKey, paymentHeaders);

        case 3:
          paymentDetailsApiResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(paymentDetailsApiResponse.status)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _payment.PAYMENT.GET_PAYMENT_DETAILS.SUCCEEDED,
            paymentDetails: paymentDetailsApiResponse.data
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _payment.PAYMENT.GET_PAYMENT_DETAILS.FAILED,
            paymentDetails: paymentDetailsApiResponse.data
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAccountCreditCards(action) {
  var accountKey, isActive, status, creditCardsApi, creditCardApiResponse;
  return _regenerator2.default.wrap(function getAccountCreditCards$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          accountKey = action.accountKey, isActive = action.isActive, status = action.status;
          creditCardsApi = new _webUtils.API();
          _context2.next = 4;
          return creditCardsApi.get(_webUtils.Urls.payment.checkIfAccountHasCards + '?accountKey=' + accountKey + '&isactive=' + isActive + '&status=' + status, paymentHeaders);

        case 4:
          creditCardApiResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(creditCardApiResponse.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)({
            type: _payment.PAYMENT.GET_CREDIT_CARDS.SUCCEEDED,
            cards: creditCardApiResponse.data
          });

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)({
            type: _payment.PAYMENT.GET_CREDIT_CARDS.FAILED,
            error: creditCardApiResponse.data
          });

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function getPaymentMethods(action) {
  var paymentMethodsApi, paymentMethodsApiResponse;
  return _regenerator2.default.wrap(function getPaymentMethods$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          paymentMethodsApi = new _webUtils.API();
          _context3.next = 3;
          return paymentMethodsApi.get(_webUtils.Urls.payment.getPaymentTypes + 'countryid=' + action.payload.countryId + '&languageId=' + action.payload.languageId, paymentHeaders);

        case 3:
          paymentMethodsApiResponse = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(paymentMethodsApiResponse.status)) {
            _context3.next = 9;
            break;
          }

          _context3.next = 7;
          return (0, _effects.put)({
            type: _payment.PAYMENT.PAYMENT_METHODS.SUCCEEDED,
            paymentMethods: paymentMethodsApiResponse.data
          });

        case 7:
          _context3.next = 11;
          break;

        case 9:
          _context3.next = 11;
          return (0, _effects.put)({
            type: _payment.PAYMENT.PAYMENT_METHODS.FAILED,
            error: paymentMethodsApiResponse.data
          });

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getVaidTransactionByTransactionKey(action) {
  var header, vaidTransactionApi, vaidTransactionApiResponse;
  return _regenerator2.default.wrap(function getVaidTransactionByTransactionKey$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          header = [{
            key: 'x-vzt-authorization',
            value: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBpZCI6InNlcnZpY2VzIiwiZXhwIjoxNTI0NDE0MDkxLjAsIm5uYyI6IjU4MDllYmIyYWQ2YjdmMmMifQ.lcVf-afeEm8KIpqFaMT3Y7hpyrPWg6fNic8Ew9YyU6k'
          }, {
            key: 'x-vzt-component',
            value: 'paymentportal'
          }];
          vaidTransactionApi = new _webUtils.API();
          _context4.next = 4;
          return vaidTransactionApi.get('' + _webUtils.Urls.payment.getTransactionByTransactionKey + action.transactionKey, header);

        case 4:
          vaidTransactionApiResponse = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(vaidTransactionApiResponse.status)) {
            _context4.next = 10;
            break;
          }

          _context4.next = 8;
          return (0, _effects.put)({
            type: _payment.VALID_TRANSACTION.SUCCEEDED,
            transactionDetails: vaidTransactionApiResponse.data
          });

        case 8:
          _context4.next = 12;
          break;

        case 10:
          _context4.next = 12;
          return (0, _effects.put)({
            type: _payment.VALID_TRANSACTION.FAILED,
            error: vaidTransactionApiResponse.data
          });

        case 12:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function addPaymentTransactionSaga(action) {
  var api, response;
  return _regenerator2.default.wrap(function addPaymentTransactionSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          api = new _webUtils.API();
          _context5.next = 3;
          return api.post(_webUtils.Urls.payment.addTransaction, action.payload, paymentHeaders);

        case 3:
          response = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 7;
          return (0, _effects.put)((0, _payment.addPaymentTransactionSucceeded)(_extends({}, response.data)));

        case 7:
          _context5.next = 11;
          break;

        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _payment.addPaymentTransactionFailed)(_extends({}, response.data)));

        case 11:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function updatePaymentMethodSaga(action) {
  var api, body, salesForcePaymentMethodHeader, response;
  return _regenerator2.default.wrap(function updatePaymentMethodSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          api = new _webUtils.API();
          body = _extends({
            PaymentMethodKey: 'pm4bcc2653a34f5454'
          }, action.payload);
          salesForcePaymentMethodHeader = [{
            key: 'CallSource',
            value: 'AccountManagement'
          }];
          _context6.next = 5;
          return api.post(_webUtils.Urls.updatePaymentMethod, body, salesForcePaymentMethodHeader);

        case 5:
          response = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context6.next = 11;
            break;
          }

          _context6.next = 9;
          return (0, _effects.put)((0, _payment.updatePaymentMethodSucceeded)(_extends({}, response.data)));

        case 9:
          _context6.next = 13;
          break;

        case 11:
          _context6.next = 13;
          return (0, _effects.put)((0, _payment.updatePaymentMethodFailed)(_extends({}, response.data)));

        case 13:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function setPaymentMethodSaga(action) {
  var api, body, culture, accountKey, header, response;
  return _regenerator2.default.wrap(function setPaymentMethodSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          api = new _webUtils.API();
          body = _extends({
            PaymentMethodKey: 'pm4bcc2653a34f5454',
            PaymentTypeKey: 'pt10673dcd39212r8'
          }, action.payload);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          header = [{
            key: 'Culture',
            value: '' + culture
          }, {
            key: 'AccountKey',
            value: '' + accountKey
          }];
          _context7.next = 7;
          return api.post(_webUtils.Urls.payment.setPaymentMethod, body, header);

        case 7:
          response = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context7.next = 13;
            break;
          }

          _context7.next = 11;
          return (0, _effects.put)((0, _payment.setPaymentMethodSucceeded)(_extends({}, response.data)));

        case 11:
          _context7.next = 15;
          break;

        case 13:
          _context7.next = 15;
          return (0, _effects.put)((0, _payment.setPaymentMethodFailed)(_extends({}, response.data)));

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function schedulesSaga() {
  return _regenerator2.default.wrap(function schedulesSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_payment.PAYMENT.GET_PAYMENT_DETAILS.LOAD, getAccountPaymentDetails);

        case 2:
          _context8.next = 4;
          return (0, _effects.takeEvery)(_payment.PAYMENT.GET_CREDIT_CARDS.LOAD, getAccountCreditCards);

        case 4:
          _context8.next = 6;
          return (0, _effects.takeEvery)(_payment.PAYMENT.PAYMENT_METHODS.LOADING, getPaymentMethods);

        case 6:
          _context8.next = 8;
          return (0, _effects.takeEvery)(_payment.VALID_TRANSACTION.LOADING, getVaidTransactionByTransactionKey);

        case 8:
          _context8.next = 10;
          return (0, _effects.takeEvery)(_payment.PAYMENT.ADD_PAYMENT_TRANSACTION.SUBMIT, addPaymentTransactionSaga);

        case 10:
          _context8.next = 12;
          return (0, _effects.takeEvery)(_payment.PAYMENT.SET_PAYMENT_METHOD.SUBMIT, setPaymentMethodSaga);

        case 12:
          _context8.next = 14;
          return (0, _effects.takeEvery)(_payment.PAYMENT.UPDATE_PAYMENT_METHOD.SUBMIT, updatePaymentMethodSaga);

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

exports.default = schedulesSaga;
module.exports = exports['default'];